import { Box, Card, CardContent, Chip, Divider, Stack, Typography } from '@mui/material';
import { CHIPS_COLOR } from '../../types/students';
import { useGetRecentSubmissionsQuery } from '../../services/submissions.service';
import { Feed, ArrowForward } from '@mui/icons-material';
import { useAppTheme } from '../../context/ThemeContext';
import { Link } from 'react-router-dom';

const ARABIC_RE = /[؀-ۿ]/;

function SubmissoinsCard() {
  const { data } = useGetRecentSubmissionsQuery('Submissions');
  const { isNewTheme, accentColor } = useAppTheme();

  return (
    <Card
      sx={
        isNewTheme
          ? {
              width: "100%",
              height: "100%",
              borderRadius: "8px",
              border: "1px solid #E2E8F0",
              boxShadow: "0 2px 6px rgba(15,23,42,0.05)",
              display: "flex",
              flexDirection: "column",
              transition: "box-shadow 0.15s ease",
              "&:hover": { boxShadow: "0 4px 16px rgba(15,23,42,0.07)" },
            }
          : {
              width: "100%",
              height: "100%",
              borderRadius: "10px",
              boxShadow: "0px 0px 55px 5px rgba(0, 0, 0, 0.05)",
              display: "flex",
              flexDirection: "column",
            }
      }>
      {/* Header */}
      <Box
        sx={{
          px: 2,
          py: 1.5,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {isNewTheme && (
            <Box
              sx={{
                width: 32,
                height: 32,
                borderRadius: "8px",
                backgroundColor: `${accentColor}1a`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}>
              <Feed sx={{ fontSize: 18, color: accentColor }} />
            </Box>
          )}
          <Typography variant="h6" fontWeight={isNewTheme ? 700 : 600} color={isNewTheme ? "text.primary" : "black"}>
            Recent Submissions
          </Typography>
        </Box>
        <Link to="/submissions" style={{ textDecoration: "none" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.3,
              color: "primary.main",
              fontSize: "0.75rem",
              fontWeight: 600,
              opacity: 0.85,
              transition: "opacity 0.15s ease",
              "&:hover": { opacity: 1 },
            }}>
            View all
            <ArrowForward sx={{ fontSize: 13 }} />
          </Box>
        </Link>
      </Box>

      <Divider sx={isNewTheme ? { borderColor: "#E2E8F0" } : {}} />

      <CardContent sx={{ flex: 1, overflow: "auto", p: 1.5 }}>
        <Stack
          direction="column"
          divider={
            <Divider sx={isNewTheme ? { borderColor: "#F1F5F9" } : {}} />
          }>
          {data?.map((submission) => {
            const isArabic = ARABIC_RE.test(submission.fullName ?? "");
            const degree = submission.degree && submission.degree !== "NONE" ? submission.degree : "—";

            return (
              <Stack
                justifyContent="space-between"
                alignItems="center"
                key={submission._id}
                direction="row"
                spacing={1}
                p={1}
                sx={
                  isNewTheme
                    ? {
                        borderRadius: "8px",
                        transition: "background 0.15s ease",
                        "&:hover": { backgroundColor: "#F8FAFC" },
                      }
                    : {}
                }>
                <Typography
                  component="span"
                  variant="body2"
                  fontWeight={isNewTheme ? 600 : 400}
                  dir={isArabic ? "rtl" : "ltr"}
                  sx={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    flex: 1,
                    textAlign: isArabic ? "right" : "left",
                  }}>
                  {submission.fullName}
                </Typography>
                <Typography
                  variant="caption"
                  color={degree === "—" ? "text.disabled" : "text.secondary"}
                  sx={{ whiteSpace: "nowrap", flexShrink: 0 }}>
                  {degree}
                </Typography>
                <Chip
                  size="small"
                  label={submission.status}
                  color={CHIPS_COLOR[submission.status]}
                  sx={{ borderRadius: isNewTheme ? "4px" : "8px", fontWeight: isNewTheme ? 600 : 400, flexShrink: 0 }}
                />
              </Stack>
            );
          })}
        </Stack>
      </CardContent>
    </Card>
  );
}

export default SubmissoinsCard;
